import { GenerateModalWithSuspense } from "@libs/modal-panels/modal-registry-helpers";
import { iModalProps } from "@libs/modal-panels/modal-registry-model";
import React from "react";

const ConversationTagsEditorModal = React.lazy(
  () => import("./conversation-tags-editor.modal"),
);

const ConversationTagsEditor: iModalProps<
  typeof ConversationTagsEditorModal,
  {}
> = {
  name: "conversation-tags-editor",
  component: GenerateModalWithSuspense(ConversationTagsEditorModal),
};

export default ConversationTagsEditor;
